import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/layout/PrivateRoute';
import Layout from './components/layout/Layout';

// Auth
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';

// Pages
import Profile from './pages/Profile';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Settings from './pages/Settings';

// NFC
import PerfilPublico from './pages/PerfilPublico';
import MisTarjetas from './pages/MisTarjetas';
import EditarPerfil from './pages/EditarPerfil';
import Tarjetas from './pages/Tarjetas';

function App() {
    return (
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                    <Routes>
                        <Route path="/login"           element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password"  element={<ResetPassword />} />
                        <Route path="/c/:codigo" element={<PerfilPublico />} />
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />

                        <Route path="/dashboard" element={
                            <PrivateRoute>
                                <Layout><div className="p-4 text-gray-500">Dashboard</div></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/profile" element={
                            <PrivateRoute>
                                <Layout><Profile /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/users" element={
                            <PrivateRoute permiso={['usuarios', 'read']}>
                                <Layout><Users /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/roles" element={
                            <PrivateRoute permiso={['roles', 'read']}>
                                <Layout><Roles /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/settings" element={
                            <PrivateRoute roles={['superadmin', 'admin']}>
                                <Layout><Settings /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/tarjetas" element={
                            <PrivateRoute permiso={['tarjetas', 'read']}>
                                <Layout><Tarjetas /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/tarjetas/:uuid/perfil" element={
                            <PrivateRoute permiso={['tarjetas', 'update']}>
                                <Layout><EditarPerfil adminMode={true} /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/mis-tarjetas" element={
                            <PrivateRoute>
                                <Layout><MisTarjetas /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/mis-tarjetas/:uuid" element={
                            <PrivateRoute>
                                <Layout><EditarPerfil /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
